import TileTemplate from "../grid/TileTemplate";
import TileType from "../grid/TileType";
import { getRuby, getGold, getOre, getUpgrade, SpecialTileTypes, TileTypeArray } from "../grid/TileTypes";
import BasicSprite from "./BasicSprite";
import Spritesheet from "./Spritesheet";

export default class TileSpritesheet extends Spritesheet {
    /**
     * @param {string} fileName 
     * @param {number} spriteSize 
     */
    constructor(fileName, spriteSize) {
        super(fileName, spriteSize);

        /**
         * @constant
         * @type {number}
         */
        this.goldRow = 0;
        /**
         * @constant
         * @type {number}
         */
        this.oreRow = 1;
        /**
         * @constant
         * @type {number}
         */
        this.rubyRow = 2;
        /**
         * @constant
         * @type {number}
         */
        this.upgradeRow = 3;


        // Tell the superclass to start loading the image.
        this.loadImage();
    }

    /**
     * @inheritdoc
     * @override
     */
    populateSpriteMap() {

        // This must match the tiles in Configs.java in TerrainSpriteGenerator

        // In the spritesheet, the first 5 rows are special:
        // row 0: GOLD
        // row 1: ORE
        // row 2: RUBY
        // row 3: UPGRADE
        // row 4: SKY
        // row 5: GRASS

        let row = 4;
        this.loadTileType(SpecialTileTypes.SKY, row);
        row++;

        this.loadTileTypePlusSpecial(SpecialTileTypes.GRASS, row);  // <-- Grass gets special blocks too
        row++;

        this.loadTileTypePlusSpecial(SpecialTileTypes.DIRT, row);
        row++;

        for (let i = 0; i < TileTypeArray.length; i++) {
            this.loadTileTypePlusSpecial(TileTypeArray[i], row);
            row++;
        }

        /////////////////////////////////////
        // Mark the spritesheet as loaded.
        /////////////////////////////////////

        this.loaded = true;
    }

    /**
     * @private
     * @param {TileType} tileType 
     * @param {number} row 
     */
    loadTileTypePlusSpecial(tileType, row) {
        this.loadTileType(tileType, row);
        
        // Load the gold, ore, and upgrade        
        this.loadTileType(getGold(tileType), this.goldRow);
        this.loadTileType(getOre(tileType), this.oreRow);
        this.loadTileType(getUpgrade(tileType), this.upgradeRow);
        this.loadTileType(getRuby(tileType), this.rubyRow);
    }

    /**
     * @private
     * @param {TileType} tileType 
     * @param {number} row 
     */
    loadTileType(tileType, row) {
        const templateWidth = (this.spriteSize + 1) * 16;  // 16 sprites per template
        const firstX = 0;
        const secondX = templateWidth;
        const thirdX = 2 * templateWidth;

        tileType.tileTemplate = this.parseTileTemplate(firstX, row);
        tileType.tileTemplate2 = this.parseTileTemplate(secondX, row);
        tileType.tileTemplate3 = this.parseTileTemplate(thirdX, row);
    }

    /**
     * @private
     * @param {TileType} tileType 
     * @param {number} x
     * @param {number} row 
     * @returns {TileTemplate}
     */
    parseTileTemplate(x, row) {
        const step = this.spriteSize + 1; // There is a 1px buffer between the sprites, only on the bottom and right edges.

        const y = row * step;

        const tileTemplate = new TileTemplate();

        //////////////////////////////////
        // One Border
        //////////////////////////////////

        tileTemplate.northBorder = new BasicSprite(this, x, y);
        x += step;
        tileTemplate.eastBorder = new BasicSprite(this, x, y);
        x += step;
        tileTemplate.southBorder = new BasicSprite(this, x, y);
        x += step;
        tileTemplate.westBorder = new BasicSprite(this, x, y);
        x += step;

        //////////////////////////////////
        // Two Borders
        //////////////////////////////////

        tileTemplate.northEastBorder = new BasicSprite(this, x, y);
        x += step;
        tileTemplate.northSouthBorder = new BasicSprite(this, x, y);
        x += step;
        tileTemplate.northWestBorder = new BasicSprite(this, x, y);
        x += step;
        tileTemplate.southEastBorder = new BasicSprite(this, x, y);
        x += step;
        tileTemplate.eastWestBorder = new BasicSprite(this, x, y);
        x += step;
        tileTemplate.southWestBorder = new BasicSprite(this, x, y);
        x += step;

        //////////////////////////////////
        // Three Borders
        //////////////////////////////////

        tileTemplate.northEastSouthBorder = new BasicSprite(this, x, y);
        x += step;
        tileTemplate.northSouthWestBorder = new BasicSprite(this, x, y);
        x += step;
        tileTemplate.northEastWestBorder = new BasicSprite(this, x, y);
        x += step;
        tileTemplate.eastWestSouthBorder = new BasicSprite(this, x, y);
        x += step;

        //////////////////////////////////
        // Four Borders
        //////////////////////////////////

        tileTemplate.northEastSouthWestBorder = new BasicSprite(this, x, y);
        x += step;

        //////////////////////////////////
        // No Borders
        //////////////////////////////////

        tileTemplate.noBorder = new BasicSprite(this, x, y);

        return tileTemplate;
    }
    
}